module.exports = __webpack_public_path__ + "img/IT.171f338c.svg";